import { buildTranslate } from 'locales'
import React from 'react'
import {
  formatUsd,
  HeroTextState,
  HERO_DISCOUNT,
  HERO_ITEMS,
  HERO_ITEM_TOTAL,
} from './timeline'

const t = buildTranslate('promo_codes.overview.hero.animation')

const STATUS_ICON_FILL = '#1c1c1e'

type Props = HeroTextState & {
  promoCode: string
}

// Wrapped in a span so the icons form an inline line box rather than a bare
// flex item, which is what sets the status bar's height.
const StatusIcons = () => (
  <span>
    <svg
      width="54"
      height="12"
      viewBox="0 0 54 12"
      fill={STATUS_ICON_FILL}
      aria-hidden="true"
    >
      <rect x="0" y="7" width="3" height="5" rx="1" />
      <rect x="5" y="5" width="3" height="7" rx="1" />
      <rect x="10" y="3" width="3" height="9" rx="1" />
      <rect x="15" y="1" width="3" height="11" rx="1" />
      <path d="M25 4.2a8 8 0 0110 0l-1.5 1.8a5.5 5.5 0 00-7 0z" />
      <path d="M27.5 7a4.5 4.5 0 015 0L30 9.6z" />
      <rect
        x="40"
        y="2"
        width="12"
        height="8"
        rx="2.2"
        fill="none"
        stroke={STATUS_ICON_FILL}
        strokeWidth="1.2"
      />
      <rect x="41.5" y="3.6" width="7" height="4.8" rx="1" />
      <rect x="52.5" y="4.4" width="1.4" height="3.2" rx=".7" />
    </svg>
  </span>
)

const TrashIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14" />
  </svg>
)

const PhoneCheckout = ({ typedCount, isTyping, total, promoCode }: Props) => {
  const typed = promoCode.slice(0, typedCount)
  const caretClassName = isTyping
    ? 'hero-phone__caret hero-phone__caret--solid'
    : 'hero-phone__caret'

  return (
    <div className="hero-phone">
      <div className="hero-phone__screen">
        <div className="hero-phone__island" />
        <div className="hero-phone__statusbar">
          <span>{t('status_time')}</span>
          <StatusIcons />
        </div>
        <div className="hero-phone__nav-title">{t('checkout')}</div>

        <div className="hero-phone__card">
          {HERO_ITEMS.map(item => (
            <div className="hero-phone__row" key={item.key}>
              <span>{t(`items.${item.key}`)}</span>
              <span className="hero-phone__amount">
                {formatUsd(item.price)}
              </span>
            </div>
          ))}
        </div>

        <div className="hero-phone__section-label">{t('promo_label')}</div>
        <div className="hero-phone__promo-row">
          <div className="hero-phone__field">
            {typed.length === 0 && (
              <span className="hero-phone__placeholder">
                {t('promo_placeholder')}
              </span>
            )}
            <span className="hero-phone__typed">{typed}</span>
            <span className={caretClassName} />
          </div>
          <div className="hero-phone__apply">{t('apply')}</div>
        </div>

        <div className="hero-phone__card hero-phone__card--totals">
          <div className="hero-phone__row">
            <span>{t('item_total')}</span>
            <span className="hero-phone__amount">
              {formatUsd(HERO_ITEM_TOTAL)}
            </span>
          </div>
          <div className="hero-phone__discount">
            <span className="hero-phone__discount-label">
              {t('discount_label', { code: promoCode })}
            </span>
            <span className="hero-phone__discount-value">
              {t('discount_amount', { amount: formatUsd(HERO_DISCOUNT) })}
              <TrashIcon />
            </span>
          </div>
          <div className="hero-phone__total-row">
            <span className="hero-phone__total-label">{t('total')}</span>
            <span className="hero-phone__total-value">{formatUsd(total)}</span>
          </div>
        </div>

        <div className="hero-phone__submit">{t('place_order')}</div>
      </div>
    </div>
  )
}

export default PhoneCheckout
